<template>
  <a class="dropdown-item cursor-pointer" @click="handle">Mark as unread</a>
</template>

<script>
import eventBus from "../../../event-bus";

export default {
  props: {
    message: Object,
    url: String,
  },

  methods: {
    /**
     * @return {undefined}
     */
    handle() {
      axios.post(this.url, {
        id: _.get(this.message, 'id'),
      })
          .then(this.onMessageUpdated)
          .catch(this.onUpdatedError);
    },

    /**
     * @param {Object} data
     * @emits on-message-mark-unread
     * @return {undefined}
     */
    onMessageUpdated({data}) {
      eventBus.$emit('on-message-mark-unread', {message: this.message});

      let message = _.get(data, 'message', null);

      if (!_.isNull(message)) {
        this.$message({
          message: message,
          type: 'success',
        });
      }
    },

    /**
     * @param {Object} response
     * @return {undefined}
     */
    onUpdatedError({response}) {
      this.$message({
        message: _.get(response, 'data.message', 'An error occurred.'),
        type: 'error',
        iconClass: 'el-icon-error',
      });
    },
  },
}
</script>

<style scoped>

</style>
